// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__10bO5","tab":"ProcedureTabs_tab__1Cybp"};